import { render, staticRenderFns } from "./CriterioRepositoryOptions.vue?vue&type=template&id=f6dbd354&scoped=true&"
import script from "./CriterioRepositoryOptions.vue?vue&type=script&lang=js&"
export * from "./CriterioRepositoryOptions.vue?vue&type=script&lang=js&"
import style0 from "./CriterioRepositoryOptions.vue?vue&type=style&index=0&id=f6dbd354&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6dbd354",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDialog,
  VIcon,
  VList,
  VListTile,
  VListTileTitle,
  VMenu,
})
